import React, { useEffect, useRef, useState } from 'react';
import { Container, makeStyles, Grid, Button, Typography, Table, TableCell, TableRow, TableBody, Fade, Stepper, Step, StepLabel, colors } from '@material-ui/core';
import Page from 'components/Page';
import { FormatNumber, Header } from 'components';
import { ModalGeneral } from 'components';
import { useForm } from 'react-hook-form';
import getErrorMessage from 'utils/getErrorMessage';
import FormularioTarea from './FormularioTarea';
import serviciosCatalogo from 'utils/serviciosCatalogo';
import serviciosSolicitudes from 'utils/serviciosSolicitudes';

const useStyles = makeStyles((theme) => ({
    step: {
        "&$completed": {
            color: "rgb(76,175,80)"
        },
        "&$active": {
            color: theme.palette.primary
        },
    },
    btnAceptar: {
        color: colors.green[500],
    },
    active: {}, //needed so that the &$active tag works
    completed: {},
    // disabled: {},
}));

const AgregarTarea = ({ setMensaje, datoS, setCargando, edicionEspecial, permisos, guardar, accion, tipo, servicios, ctlg, ...props }) => {
    //inicializa variables
    const classes = useStyles();
    const formref = useRef();
    const [mAdvertencia, setMAdvertencia] = useState({ open: false, titulo: '' });
    const { register, unregister, handleSubmit, errors, watch, setValue, getValues, control } = useForm();
    const cerrarAdvertencia = () => setMAdvertencia({ open: false, titulo: '' });
    useEffect(() => {
        register('idsolicitud');
        register('titulo', { required: { value: true, message: 'Campo requerido' } });
        register('descripcion', { required: { value: true, message: 'Campo requerido' } });
        register('prioridad', { required: { value: true, message: 'Campo requerido' } });
    }, []);
    return (
        <Container maxWidth={false}>

            <Container>
                <form autocomplete="off" onSubmit={handleSubmit(guardar)}>
                    <FormularioTarea
                        register={register}
                        datoS={datoS}
                        errors={getErrorMessage(errors)}
                        watch={watch}
                        ctl={ctlg}
                        setValue={setValue} />
                    <Grid item container justify="flex-end">
                        <Button variant="text" color="primary" /*onClick={()=>guardar(dataReq)}*/ type="submit" style={{ color: colors.green[500] }}>GUARDAR</Button>
                    </Grid>
                </form>
            </Container>


            <ModalGeneral
                open={mAdvertencia.open}
                titulo='Advertencia'
                width='sm'
                ContenidoMensaje={mAdvertencia.mensaje}
                acciones={<React.Fragment>
                    <Button className="btnError" color="secondary" onClick={cerrarAdvertencia}>CERRAR</Button>
                    {Boolean(mAdvertencia.aceptar) &&
                        <Button color="primary" style={{ color: colors.green[500] }} onClick={mAdvertencia.aceptar}>ACEPTAR</Button>
                    }
                </React.Fragment>}
            />
        </Container>
    );
};

export default AgregarTarea;